import React, { useState } from 'react';
import styled from 'styled-components';
import Loader from '../Components/Loader'; 
import SuccessCard from '../Components/SuccessCard'; 
import ErrorCard from '../Components/ErrorCard'; 
import useAddIaProfile from '../Hooks/IAprofileHooks/useAddIaProfile';
import MunicipalitySelector from '../Components/Municipality';
import MailingAddressSelector from '../Components/MailingAddressSelector';


const IaProfilingAdd = ({darkMode}) => {

  const { loading, success, error, addIaProfile } = useAddIaProfile();
  const [showSuccess, setShowSuccess] = useState(false);
  const [showError, setShowError] = useState(false);


    const initialFormData = {
      name_of_irrigators: '',
      name_of_cis: '',
      municipality: '',
      district_number: '',
      mailing_address: '',
      name_of_iaPresident: '',
      contactNumber: '',
      date_organized: '',
      sec_number: '',
      sec_date: '',
      ia_tin: '',
      permit_number: '',
      permit_date: '',
      membership_potl: '',
      membership_actual: '',
      number_of_TSAG: '',
      serviceArea: '',
      fusa: '',
      operational_area: '',
      date_moaSigned: '',
      f_source: '',
      proj_cost: '',
      date_turnover: '',
      total_loanBalance: '',
      status: '',
      imtContract_dateSigning: '',
      imtContract_underContract: '',
      canalLength_unlined: '',
      canalLength_lined: '',
      remarks: '',
    };
    const [formData, setFormData] = useState(initialFormData); 
  const [isExpanded] = useState(true);

  const formSections = [
    {
      title: null,
      fields: [
        'name_of_irrigators',
        'name_of_cis',
        'municipality',
        'district_number',
        'mailing_address',
        'name_of_iaPresident',
        'contactNumber',
        'date_organized',
      ],
    },
    {
      title: 'SEC/CDA/DOLE Reg.',
      fields: ['sec_number', 'sec_date'],
    },
    {
      title: null,
      fields: ['ia_tin'],
    },
    {
      title: 'Water Permit',
      fields: ['permit_number', 'permit_date'],
    },
    {
      title: 'Membership',
      fields: ['membership_potl', 'membership_actual'],
    },
    {
      title: null,
      fields: ['number_of_TSAG', 'serviceArea', 'fusa', 'operational_area'],
    },
    {
      title: 'Original Construction',
      fields: ['date_moaSigned', 'f_source', 'proj_cost', 'date_turnover'],
    },
    {
      title: null,
      fields: ['total_loanBalance', 'status'],
    },
    {
      title: 'IMT Contract',
      fields: ['imtContract_dateSigning', 'imtContract_underContract'],
    },
    {
      title: 'Canal Length',
      fields: ['canalLength_unlined', 'canalLength_lined'],
    },
    {
      title: null,
      fields: ['remarks'],
    },
  ];

  const fieldLabelMap = {
    name_of_irrigators: 'NAME OF IRRIGATORS ASSOCIATION',
    name_of_cis: 'Name of CIS/SIS-SRIS/SIP/PIP/SRIP',
    municipality: 'Municipality',
    district_number: 'District No.',
    mailing_address: 'Mailing Address',
    name_of_iaPresident: 'Name of IA President',
    contactNumber: 'Contact Number',
    date_organized: 'Date Organized',

    sec_number: 'Number',
    sec_date: 'Date',
    ia_tin: 'IA Tin',
  
    permit_number: 'Number',
    permit_date: 'Date',
  
    membership_potl: 'Potl',
    membership_actual: 'Actual',
  
    number_of_TSAG: 'No. of TSAG',
    serviceArea: 'Service Area',
  
    fusa: 'Fusa',
    operational_area: 'Operational Area',

    date_moaSigned: 'DATE of MOA signed',
    f_source: 'F-Source',
    proj_cost: 'Proj Cost (000)',
    date_turnover: 'DATE of TURNOVER',

    total_loanBalance: 'Total IA Loan Balance',
    status: 'Status',

    imtContract_dateSigning: 'DATE OF SIGNING',
    imtContract_underContract: 'AREA UNDER CONTRACT',

    canalLength_unlined: 'UNLINED',
    canalLength_lined: 'LINED',

    remarks: 'Remarks',

  };
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const result = await addIaProfile(formData);
  
    if (result?.success) {
      setShowSuccess(true);
      setFormData(initialFormData); // ✅ Reset the form here
    } else {
      setShowError(true);
    }
  };
  
  

  return (
    <Container darkMode={darkMode}  isExpanded={isExpanded}>
      <FormContainer  darkMode={darkMode} isExpanded={isExpanded}>
      <Title darkMode={darkMode}><span>IA Profiling Form</span></Title>
      {loading && <LoaderOverlay><Loader /></LoaderOverlay>}
      {showSuccess && <SuccessCard onClose={() => setShowSuccess(false)} />}
      {showError && <ErrorCard errorMessage={error} onClose={() => setShowError(false)} />}

        <form onSubmit={handleSubmit}>
        {formSections.map((section, index) => (
<CardSection darkMode={darkMode} key={index}>
  {section.title && (
    <SectionHeader darkMode={darkMode}>{section.title}</SectionHeader>
  )}

  {section.fields.map((key) => (
    <FieldGroup key={key} darkMode={darkMode}>
       <label htmlFor={key}>
          {fieldLabelMap[key] || key.replace(/_/g, ' ').toUpperCase()}
      </label>

      {key === 'municipality' ? (
        <MunicipalitySelector
          formData={formData}
          setFormData={setFormData}
          darkMode={darkMode}
        />
      ) : key === 'mailing_address' ? (
        <MailingAddressSelector
          formData={formData}
          setFormData={setFormData}
          darkMode={darkMode}
        />
      ) : ['date_organized', 'imtContract_dateSigning', 'sec_date', 'permit_date'].includes(key) ? (
        <input
          type="date"
          className="form-control"
          id={key}
          name={key}
          value={formData[key]}
          onChange={handleChange}
        />
      ) : (
        <input
          type="text"
          className="form-control"
          id={key}
          name={key}
          value={formData[key]}
          onChange={handleChange}
        />
      )}
    </FieldGroup>
  ))}
</CardSection>
))}

          <FormButtonContainer>
            <SubmitButton darkMode={darkMode}type="submit">Add</SubmitButton>
          </FormButtonContainer>
        </form>
      </FormContainer>
    </Container>
  );
};

export default IaProfilingAdd;

const Container = styled.div`
  padding: ${(props) => (props.isExpanded ? '1px' : '10px')};
  width: 100%;
  height: 100%;
  min-height: 100vh;
  background-size: 100%;
  background-position: center;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  overflow-y: auto;
  position: relative;
  transition: transform 0.3s ease; 
  transform: ${(props) => (props.isExpanded ? 'translateX(0%)' : 'translateX(80%)')};
  
  margin-top: 10px;
`;


const FormContainer = styled.div`
  width: ${(props) => (props.isExpanded ? '75%' : '100%')};
  margin-top: 0px;
  padding-bottom: 20px;
  flex-grow: 1;
  overflow-y: auto;
  transition: width 0.3s ease;
  
`;

const Title = styled.h2`
  position: sticky;
  top: 0;
  z-index: 100;
  padding: 10px 0;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  backdrop-filter: ${({ darkMode }) => (darkMode ? 'blur(10px)' : 'none')};
  -webkit-backdrop-filter: ${({ darkMode }) => (darkMode ? 'blur(10px)' : 'none')};
  background: ${({ darkMode }) =>
    darkMode
      ? 'rgba(3, 82, 33, 0.45)'
      : 'rgba(255, 255, 255, 0.65)'};

  box-shadow: ${({ darkMode }) =>
    darkMode
      ? '0 4px 30px rgba(0, 0, 0, 0.1)'
      : '0 4px 30px rgba(0, 0, 0, 0.05)'};

  span {
    background-color: ${({ darkMode }) => (darkMode ? 'rgba(255, 255, 255, 0.6)' : '#18591d')};
    color: ${({ darkMode }) => (darkMode ? '#1a1a1a' : '#fff')};
    padding: 6px 24px;
    font-size: 1rem;
    font-weight: bold;
    border-radius: 8px;
    position: relative;
    z-index: 1;
  }

  &::before,
  &::after {
    content: '';
    flex: 1;
    height: 2px;
    width: 30px;
    background-color: ${({ darkMode }) => (darkMode ? '#eee' : '#333')};
    margin: 0 8px;
    margin-top: 35px;
  }
`;



const LoaderOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999; // on top of everything
`;


const CardSection = styled.div`
  background: ${({ darkMode }) => (darkMode ? 'rgba(3, 82, 33, 0.3)' : '#fff')};
  backdrop-filter: ${({ darkMode }) => (darkMode ? 'blur(9px)' : 'none')};
  -webkit-backdrop-filter: ${({ darkMode }) => (darkMode ? 'blur(10px)' : 'none')};
  padding: 13px;
  margin-bottom: 7px;
  border-radius: 10px;
  box-shadow: ${({ darkMode }) =>
    darkMode ? '0 3px 8px rgba(255, 255, 255, 0.4)' : '0 3px 10px rgba(0, 0, 0, 0.05)'};
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 15px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;


const SectionHeader = styled.h3`
grid-column: span 2;
font-size: .85rem;
margin-bottom: 10px;
color: ${({ darkMode }) => (darkMode ? '#fff' : '#333')};
border-bottom: 1px solid #ccc;
padding-bottom: 5px;
`;


const FieldGroup = styled.div`
  display: flex;
  flex-direction: column;

  label {
    font-weight: bold;
    font-size: .75rem;
    margin-bottom: 5px;
    color: ${({ darkMode }) => (darkMode ? '#f2f2f2' : '#333')};
  }

  input {
    padding: 3px;
    font-size: 1rem;
    border-radius: 6px;
    border: 1px solid ;
    color: ${({ darkMode }) => (darkMode ? '#333' : '#333')};
    background-color: ${({ darkMode }) => (darkMode ? '#dcdcdc' : '#f2f2f2')};
    width: 100%;
  }
`;

const FormButtonContainer = styled.div`
  text-align: center;
  margin-bottom: 30px;
`;

const SubmitButton = styled.button`
  background: ${({ darkMode }) => (darkMode ? '#f2f2f2' : '#18591d')};
  color: ${({ darkMode }) => (darkMode ? '#333' : '#fff')};
  font-weight: bold;
  padding: 10px 100px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  &:hover {
    background-color: #218838;
  }
`;

